<template>
    <div v-if="course.id">
        <card-header title="Enrollment Course Responses" icon="fa-comments"></card-header>

<!--        <card-toolbar>-->
<!--            <button @click="exportResponses()"><i class="far fa-file-excel"></i>Export</button>-->
<!--        </card-toolbar>-->

        <card-body>

            <card-list>
                <template v-for="s in inputComponents">
                    <subheader-list-item :title="s.title" icon="fa-list-alt" />

                    <template v-for="c in s.components">

                        <subheader-list-item :title="c.title" :icon="{'fa-memo-pad': c.type === 'LESSON', 'fa-message-question': c.type === 'QUIZ', 'fa-location-check': c.type === 'CHECKPOINT'}" />

                        <card-list-item
                            chevron
                            v-for="i in c.inputs"
                            @click="$openCard('all-responses-data', {courseId: course.id, inputId: i.content.id}, card)"
                            :class="{'active': (child && child.definition.component === 'all-responses-data' && i.content.id === child.props.inputId)}"
                        >
                            <template v-slot:icon><i class="far fa-fw fa-keyboard"></i></template>
                            <template v-slot:content>
                                <div class="meta">{{ i.component.replace('DropdownField', 'Dropdown Select Question').replace('TextArea', 'Text Area Question').replace('TextField', 'Text Field Question').replace('CheckBox', 'Checkbox/Switch') }}</div>
                                <div class="tile-title">
                                    <span v-if="i.content.title">{{ i.content.title }}</span>
                                    <span v-else>Untitled Input Block<i class="fad fa-exclamation-triangle ml-2 has-text-warning"></i></span>
                                </div>
                            </template>
                            <template v-slot:details>
                                <div class="tile-details mt-4">
                                    <div class="data mt-1">
                                        <data-row mini title="Field">{{ i.content.id }}</data-row>
                                    </div>
                                </div>
                            </template>
                        </card-list-item>
                    </template>
                </template>

            </card-list>

        </card-body>
    </div>
</template>
<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../../components/tiles/ConferenceTile";

    import {client as http, apiUrl} from "@/http_client";
    import moment from "moment";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";
    import CardListItem from "../../../TIER/components/CardListItem.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardListItem, ApplicantTile, ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                course: {},
                apiUrl: apiUrl
            };
        },
        methods: {
            loadCourse: function (force) {
                this.$emit('loading', true);
                http.get('courses/new/' + this.props.courseId, {force}).then(response => {
                    this.course = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.loadCourse(true);
            },
            exportResponses: function () {
                this.$emit('loading', true);

                http.post(`${this.apiUrl}courses/responses/csv-export`, {courseId: parseInt(this.props.courseId)})
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'responses.csv');
                        document.body.appendChild(link);
                        link.click();
                        this.$emit('loading', false);
                    })
                    .catch(error => {
                        console.log(error);
                        this.$emit('loading', false);

                        if (error.response.status === 404) {
                            window.alert('No responses to export');
                        } else {
                            window.alert('Error exporting responses');
                        }
                    });
            },
        },
        computed: {
            inputComponents: function () {
                if (this.course.id) {
                    let sections = {};
                    this.course.course_outline.forEach(outline => {
                        outline.sections.section_components.forEach(component => {
                            let content = component.components.content.content;

                            if (component.components.type === 'CHECKPOINT') {
                                if (!sections[outline.id]) {
                                    sections[outline.id] = {
                                        title: outline.title,
                                        components: {}
                                    };
                                }
                                if (!sections[outline.id].components[component.component_id]) {
                                    sections[outline.id].components[component.component_id] = {
                                        title: component.components.title,
                                        type: component.components.type,
                                        inputs: []
                                    };
                                }

                                sections[outline.id].components[component.component_id].inputs.push({
                                    content: {
                                        id: component.components.content.attributes.id,
                                        title: component.components.title,
                                    },
                                    component: 'Checkpoint: ' + component.components.content.attributes.type.replace('ReflectionCheckpoint', 'Reflection/Open Question')
                                });

                            } else if (content.length) {
                                content.forEach(c => {
                                    if (c.component === 'DropdownField' || c.component === 'TextField' || c.component === 'TextArea' || c.component === 'CheckBox') {

                                        if (!sections[outline.id]) {
                                            sections[outline.id] = {
                                                title: outline.title,
                                                components: {}
                                            };
                                        }
                                        if (!sections[outline.id].components[component.component_id]) {
                                            sections[outline.id].components[component.component_id] = {
                                                title: component.components.title,
                                                type: component.components.type,
                                                inputs: []
                                            };
                                        }

                                        sections[outline.id].components[component.component_id].inputs.push(c);
                                    }
                                });
                            }

                        });
                    });

                    return sections;
                } else {
                    return false;
                }
            }
        },
        watch: {
            'props.courseId': function () {
                this.loadCourse(true);
            }
        },
        mounted: function () {
            this.loadCourse();
        }
    };
</script>

<style lang="scss" scoped>

    .tile-title {
        font-size: .9rem;
        font-weight: 700;
    }
</style>
